import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ChefHat, Coffee, CookingPot, Pizza, Soup, UtensilsCrossed } from "lucide-react";

const AuthLayout = ({ children, title, promoImage = "/images/reg-page-2.png" }) => {
  const reduceMotion = useReducedMotion();
  const entrance = reduceMotion ? {} : { initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0 } };

  return (
    <div className="min-h-screen overflow-hidden bg-[#f4faf8] lg:flex" dir="rtl">
      <main className="relative z-10 flex min-h-screen flex-1 items-center justify-center px-5 py-8 sm:px-8 lg:w-[56%] lg:flex-none">
        <motion.div
          aria-hidden="true"
          animate={reduceMotion ? {} : { y: [0, -12, 0], rotate: [-4, 4, -4] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          className="pointer-events-none absolute left-[7%] top-[15%] hidden text-secondary/30 sm:block"
        >
          <Pizza size={42} strokeWidth={1.35} />
        </motion.div>
        <motion.div
          aria-hidden="true"
          animate={reduceMotion ? {} : { y: [0, 10, 0], rotate: [5, -5, 5] }}
          transition={{ duration: 6.5, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
          className="pointer-events-none absolute bottom-[14%] left-[11%] hidden text-secondary/25 sm:block"
        >
          <Coffee size={36} strokeWidth={1.35} />
        </motion.div>
        <motion.div
          aria-hidden="true"
          animate={reduceMotion ? {} : { y: [0, -9, 0], rotate: [-6, 6, -6] }}
          transition={{ duration: 5.8, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
          className="pointer-events-none absolute right-[8%] top-[22%] hidden text-secondary/30 sm:block"
        >
          <CookingPot size={40} strokeWidth={1.35} />
        </motion.div>
        <motion.div
          aria-hidden="true"
          animate={reduceMotion ? {} : { y: [0, 11, 0], rotate: [3, -3, 3] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
          className="pointer-events-none absolute left-[4%] top-[54%] hidden text-secondary/20 sm:block"
        >
          <Soup size={32} strokeWidth={1.35} />
        </motion.div>
        <motion.div
          aria-hidden="true"
          animate={reduceMotion ? {} : { y: [0, -10, 0], rotate: [-5, 5, -5] }}
          transition={{ duration: 6.2, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
          className="pointer-events-none absolute bottom-[13%] right-[10%] hidden text-secondary/25 sm:block"
        >
          <ChefHat size={38} strokeWidth={1.35} />
        </motion.div>
        <motion.div
          aria-hidden="true"
          animate={reduceMotion ? {} : { y: [0, 8, 0], rotate: [7, -4, 7] }}
          transition={{ duration: 5.4, repeat: Infinity, ease: "easeInOut", delay: 2.1 }}
          className="pointer-events-none absolute right-[4%] top-[58%] hidden text-secondary/20 sm:block"
        >
          <UtensilsCrossed size={31} strokeWidth={1.35} />
        </motion.div>
        <motion.div {...entrance} transition={{ duration: 0.5, ease: "easeOut" }} className="relative z-10 w-full max-w-[410px]">
          <Link to="/" className="mx-auto mb-6 block w-fit rounded-lg transition-transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-primary/20" aria-label="بازگشت به صفحه اصلی">
            <img src="/images/mizban.png" alt="Mizban" className="h-auto w-32" />
          </Link>
          <section className="rounded-[28px] border border-gray-100 bg-white/95 px-6 py-7 shadow-[0_18px_45px_rgba(31,109,92,0.10)] backdrop-blur sm:px-8">
            {title && <h1 className="mb-5 text-center text-2xl font-bold tracking-tight text-accent">{title}</h1>}
            <div className="space-y-4">{children}</div>
          </section>
          <p className="mt-5 text-center text-xs leading-6 text-gray-400">بدون نیاز به رمز عبور؛ فقط با شماره موبایل وارد شوید.</p>
        </motion.div>
      </main>
      <aside className="relative hidden min-h-screen flex-1 items-center justify-center overflow-hidden bg-gradient-to-br from-[#ff8c34] via-primary to-[#f56d1c] px-10 lg:flex lg:w-[44%] lg:flex-none">
        <motion.div animate={reduceMotion ? {} : { x: [0, 20, 0], y: [0, 14, 0] }} transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }} className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
        <motion.div animate={reduceMotion ? {} : { x: [0, -18, 0], y: [0, -12, 0] }} transition={{ duration: 11, repeat: Infinity, ease: "easeInOut" }} className="absolute -bottom-32 -right-20 h-96 w-96 rounded-full bg-[#fbc28e]/30 blur-3xl" />
        <motion.div initial={reduceMotion ? false : { opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7, delay: 0.15 }} className="relative w-full max-w-md text-center">
          <img src={promoImage} alt="" className="mx-auto max-h-[62vh] w-full select-none object-contain animate-auth-float motion-reduce:animate-none" />
          <div className="mx-auto mt-4 w-fit text-sm text-white">منوی دیجیتال، مدیریت ساده‌تر</div>
          <img src="/images/mizban.png" alt="Mizban" className="mx-auto mt-5 h-auto w-40 drop-shadow-sm" />
        </motion.div>
      </aside>
    </div>
  );
};

export default AuthLayout;
